export default __webpack_public_path__ + "static/media/go-maxi.6ec0d06c.mp4";